"use strict";
/* globals module */
/**
 * @module notificationsSubscriptionsClient
 * @description  Notifications Subscriptions Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsClient` uses `notificationsSubscriptionsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var _1 = require("./");
var NotificationsSubscriptionsClient = /** @class */ (function () {
    function NotificationsSubscriptionsClient(notificationsSubscriptionsRoute, notificationsSubscriptionsAnonymousClient, notificationsSubscriptionsUsersClient) {
        this.notificationsSubscriptionsRoute = notificationsSubscriptionsRoute;
        this.notificationsSubscriptionsAnonymousClient = notificationsSubscriptionsAnonymousClient;
        this.notificationsSubscriptionsUsersClient = notificationsSubscriptionsUsersClient;
    }
    Object.defineProperty(NotificationsSubscriptionsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsClient.prototype, "anonymous", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsClient.prototype, "users", {
        get: function () {
            return this.notificationsSubscriptionsUsersClient;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsSubscriptionsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsRoute !== "undefined" && _1.NotificationsSubscriptionsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsAnonymousClient !== "undefined" && _1.NotificationsSubscriptionsAnonymousClient) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsSubscriptionsUsersClient !== "undefined" && _1.NotificationsSubscriptionsUsersClient) === "function" ? _c : Object])
    ], NotificationsSubscriptionsClient);
    return NotificationsSubscriptionsClient;
}());
exports.NotificationsSubscriptionsClient = NotificationsSubscriptionsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
